import React from 'react';
import { HERO_BG } from '../../../constants/site';

export const HeroBackground = () => (
  <div className="absolute inset-0">
    <img src={HERO_BG} alt="Luxury coastal property – Virginia and North Carolina real estate with Jessica Burnette REALTOR®" className="w-full h-full object-cover" fetchPriority="high" decoding="async" />
    <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent"></div>
    <div className="absolute top-20 left-20 w-2 h-2 bg-gold-400 rounded-full animate-ping"></div>
    <div className="absolute top-40 right-32 w-2 h-2 bg-gold-400 rounded-full animate-ping" style={{ animationDelay: '0.5s' }}></div>
    <div className="absolute bottom-40 left-32 w-2 h-2 bg-gold-400 rounded-full animate-ping" style={{ animationDelay: '1s' }}></div>
  </div>
);
